import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import DerivedFieldDetail from './DerivedFieldDetail';
export default class ListCollectionFunction extends Component {
  static propTypes = {
    projectId: PropTypes.string.isRequired,
    utilities: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
    collection: PropTypes.object.isRequired,
  };

  showUtilitiesDetail = (utility) => {
    const {
      projectId,
      collection,
      actions,
      commonActions,
      version,
      showUtilityDeleteLoader,
      deleteFlag,
    } = this.props;
    return (
      <AccordionItem key={utility.name}>
        <AccordionItemHeading>
          <AccordionItemButton>
            <i className={`wb`}></i> <strong>{utility.name}</strong>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <DerivedFieldDetail
            projectId={projectId}
            collection={collection}
            utility={utility}
            actions={actions}
            commonActions={commonActions}
            version={version}
            showUtilityDeleteLoader={showUtilityDeleteLoader}
            deleteFlag={deleteFlag}
          />
        </AccordionItemPanel>
      </AccordionItem>
    );
  };
  render() {
    const { utilities } = this.props;
    if (utilities && utilities.length > 0) {
      return (
        <div className="row modal-scroll">
          <div className="col-12">
            <Accordion allowZeroExpanded>
              {utilities.map((utility) => this.showUtilitiesDetail(utility))}
            </Accordion>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <h5 className="text-center">No Derived Fields!</h5>
        </div>
      );
    }
  }
}
